import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { getBrandLogo } from './getBrandLogo';

interface BrandLogoProps {
  noddiColor?: string;
}

export function BrandLogo({ noddiColor }: BrandLogoProps) {
  const { currentBrand } = useCurrentBrand();

  return <>{getBrandLogo({ brand: currentBrand, noddiColor })}</>;
}
